function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleDownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31 16a15 15 0 10-30 0 15 15 0 0030 0zm-15.03 7.5a1.201 1.201 0 01-.87-.354l-4.923-4.938a1.208 1.208 0 111.707-1.71l2.895 2.892V9.7a1.2 1.2 0 112.4 0v9.717l2.919-2.919a1.21 1.21 0 111.71 1.71l-4.923 4.938a1.198 1.198 0 01-.855.354h-.06z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleDownFilled;